import { QueryKey, QueryConfig, useQuery } from 'react-query';
import useHeaders from './useHeaders';
import useResponseHandler from './useResponseHandler';

export type FetchMethod = 'GET' | 'POST' | 'PATCH' | 'PUT' | 'DELETE';
export type FetchConfig<TResult> = {
  method?: FetchMethod;
  mapper?: (data: any) => TResult;
  options?: QueryConfig<any, any>;
};

const DEFAULT_CONFIG: FetchConfig<unknown> = {
  method: 'GET',
  mapper: undefined,
  options: {
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
  },
};

const useCachedFetch = <TResult>(
  queryKey: QueryKey,
  apiRoute: string,
  config?: FetchConfig<TResult>
) => {
  const configuration: FetchConfig<TResult | unknown> = {
    method: config?.method || DEFAULT_CONFIG.method,
    mapper: config?.mapper || DEFAULT_CONFIG.mapper,
    options: {
      ...DEFAULT_CONFIG.options,
      ...config?.options,
    },
  };
  const headers = useHeaders();
  const responseHandler = useResponseHandler(configuration.mapper);
  return useQuery<TResult>({
    queryKey,
    queryFn: () =>
      fetch(apiRoute, {
        method: configuration.method,
        headers,
      }).then(responseHandler),
    config: configuration.options,
  });
};

export default useCachedFetch;
